
function findNumberBeforeZ(svg, occurrence) {
    const regex = /(\d+)\sZ"/g;
    let match;
    let count = 0;
  
    while ((match = regex.exec(svg)) !== null) {
      count++;
      if (count === occurrence) {
        return match[1]; // Return the number as a string
      }
    }  
    return null; // Return null if the specified occurrence is not found
  }
  
  function findTwoMinValuesInArray(arr) {
    if (arr.length < 2) {
      console.log("file paintsvg.js, function findTwoMinValuesInArray::Array must contain at least two elements");
      return;
      throw new Error("Array must contain at least two elements");
    }
  
    let min1 = Infinity;
    let min2 = Infinity;
  
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] < min1) {
        min2 = min1;
        min1 = arr[i];
      } else if (arr[i] < min2) {
        min2 = arr[i];
      }
    }
    return [min1, min2];
  }
  
  
  export function paintSVG(svg, columns = 4) {
    // Step 1: Normalize SVG (remove hidden symbols, extra spaces, and line breaks)
    svg = svg.replace(/\s+/g, ' ').trim();
  
    // Step 2: Inject <defs> section if missing
    if (!svg.includes('<defs>')) {
        svg = svg.replace(
            /<svg[^>]*?>/,
            match =>
                `${match} <defs> <linearGradient id="innerGradient" x1="0%" y1="100%" x2="0%" y2="0%"> <stop offset="0%" stop-color="lightgrey"/> <stop offset="100%" stop-color="white"/> </linearGradient> </defs>`
        );
    }
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace(' Z M ', ' Z"/><path d="M ');
    svg = svg.replace('/>/>', '/>');
    
    const integers = [];
    integers.push(findNumberBeforeZ(svg, 1));
    integers.push(findNumberBeforeZ(svg, 2));
    integers.push(findNumberBeforeZ(svg, 3));
    integers.push(findNumberBeforeZ(svg, 4));
    integers.push(findNumberBeforeZ(svg, 5));
    integers.push(findNumberBeforeZ(svg, 6));
    integers.push(findNumberBeforeZ(svg, 7));
  
    const filteredArray = integers.filter(value => value !== undefined && value !== null && value !== "");
  
    const minValues = findTwoMinValuesInArray(filteredArray);
  
    if (!Array.isArray(minValues) || minValues.length !== 2) { // if minValues is not array and it doesn't contain 2 elements only
      return svg;
    }

    svg = svg.replace(' ' + minValues[0] + ' Z"', ' ' + minValues[0] + ' ZZZZ" fill="url(#innerGradient)"/>');
    if (columns === 4){
      svg = svg.replace(' ' + minValues[1] + ' Z"', ' ' + minValues[1] + ' ZZZZ" fill="url(#innerGradient)"/>');
    }
    svg = svg.replace('ZZZZ', 'Z');
    svg = svg.replace('ZZZZ', 'Z');
  
    return svg;
  }
  